import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SuitPressIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SuitPressIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.4503 8.69099C12.1766 8.69099 11.9538 8.91343 11.9538 9.18711V9.84605C11.9538 10.1197 12.1766 10.3422 12.4503 10.3422C12.7239 10.3422 12.9464 10.1197 12.9464 9.84605V9.18711C12.9464 8.91342 12.7239 8.69099 12.4503 8.69099Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.4503 12.228C12.1766 12.228 11.9538 12.4504 11.9538 12.7241V13.3831C11.9538 13.6568 12.1766 13.8795 12.4503 13.8795C12.7239 13.8795 12.9464 13.6567 12.9464 13.3831V12.7241C12.9464 12.4504 12.7239 12.228 12.4503 12.228Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.1676 4.04144H17.3076L16.4517 2.36863C16.3774 2.20058 16.2132 2.0932 16.0309 2.0932L8.87525 2.09355C8.69291 2.09355 8.52556 2.20128 8.44711 2.37177L7.59293 4.04179H5.73255C4.44047 4.04179 3.38965 5.09261 3.38965 6.38435V21.411C3.38965 21.6844 3.61244 21.9068 3.88612 21.9068H21.0144C21.2881 21.9068 21.5105 21.6844 21.5105 21.411V6.38434C21.5105 5.09226 20.4597 4.04144 19.1676 4.04144ZM17.2605 5.03404H18.0893L18.1346 10.5779L17.0385 11.2943C16.8464 11.4199 16.7655 11.659 16.8418 11.8759L17.6109 14.0441L13.3609 19.218L15.9939 6.86861L17.2605 5.03404ZM16.4252 4.49678L14.395 7.43692L13.1727 6.46141L15.8925 3.45608L16.4252 4.49678ZM14.8884 3.08616L12.4503 5.7798L10.0122 3.08616H14.8884ZM9.00774 3.45607L11.7275 6.4614L10.5052 7.43691L8.47536 4.49677L9.00774 3.45607ZM6.80639 5.03404H7.63966L8.90664 6.86862L11.4981 19.0235L7.71532 14.0134L8.08035 11.7901C8.11208 11.5963 8.02631 11.4017 7.8621 11.2943L6.76561 10.5779L6.80639 5.03404ZM4.38225 20.9145V6.38434C4.38225 5.63998 4.9882 5.03403 5.73256 5.03403H5.81345L5.77057 10.8411C5.76918 11.0109 5.85355 11.1678 5.99545 11.2605L7.04801 11.9484L6.70111 14.0622C6.67915 14.1954 6.71296 14.3335 6.79455 14.4416L11.6812 20.9145L4.38225 20.9145ZM10.3002 8.64288C10.3089 8.64462 10.3176 8.64637 10.3263 8.64741C10.4616 8.66833 10.6018 8.62963 10.7088 8.54456L12.4503 7.15485L14.1914 8.54456C14.2981 8.62963 14.4418 8.66903 14.5732 8.64741C14.5823 8.64636 14.5913 8.64462 14.6 8.64288L12.4499 18.7278L10.3002 8.64288ZM20.518 20.9145H13.2522L18.5565 14.4569C18.6663 14.3237 18.6987 14.1389 18.6408 13.9765L17.9083 11.9121L18.9051 11.2605C19.0474 11.1674 19.1314 11.0105 19.1296 10.8408L19.0822 5.03404H19.1676C19.912 5.03404 20.518 5.63999 20.518 6.38435V20.9145Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SuitPressIcon;
